import * as React from 'react';
import { useEffect, useState } from 'react';
import classnames from 'classnames';

/**
 * Toggler component.
 *
 * @param {Object} props
 *
 * @returns {JSX.Element}
 */
export default function (props) {
  const {onChangeCallback, enabled = false} = props;
  const [isOn, setIsOn] = useState(enabled);
  const [cssClasses, setCssClasses] = useState({
    root: '',
    button: '',
    toggler: '',
  });

  const onClickCallback = () => {
    setIsOn(!isOn);
    onChangeCallback(!isOn);
  };

  useEffect(() => {
    setIsOn(enabled);
  }, [enabled])

  useEffect(() => {
    setCssClasses(Object.assign({}, cssClasses, {
      root: classnames({
        'nv-toggler': true,
        'nv-toggler--enabled': isOn,
      }),
      button: classnames({
        'nv-toggler__button': true,
      }),
      toggler: classnames({
        'nv-toggler__indicator': true,
      })
    }));
  }, [isOn]);

  return (
    <div className={cssClasses.root}>
      <button className={cssClasses.button} onClick={onClickCallback}>
        <div className={cssClasses.toggler}></div>
      </button>
    </div>
  );
}
